import React from "react";
import classes from "./CmsPage.module.css";
import { useCmsPage } from "../../Pregrine/CmsPage/useCmsPage";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import DOMPurify from "dompurify";
import LoadingIndicator from "../LoadingIndicator";

const CmsPage = (props) => {
  const { identifier } = props;

  const talonProps = useCmsPage({ identifier });
  const { cmsPage, hasContent, shouldShowLoadingIndicator } = talonProps;

  if (shouldShowLoadingIndicator) {
    return <LoadingIndicator />;
  }

  if (hasContent) {
    const { content_heading, content } = cmsPage;

    const headingElement =
      content_heading !== "" ? (
        <div className="col-12 pb-2">
          <h1 className={classes.title}>{content_heading}</h1>
        </div>
      ) : null;

    const sanitizedHtml = DOMPurify.sanitize(content);
    const cleanedHtml = sanitizedHtml
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">");

    return (
      <div className="container">
        <div className={classes.root}>
          {headingElement}
          <div dangerouslySetInnerHTML={{ __html: cleanedHtml }} />
        </div>
      </div>
    );
  } else {
    return <>No Content Found</>;
  }
};

export default CmsPage;
